import * as React from 'react';
import Layout from '@features/workspace/components/layouts/v1/layout';
import PageNotFound from '@features/workspace/components/errors/page-not-found';

const NotFoundPage: React.FC = () => {
  return (
    <>
      <Layout>
        <PageNotFound />
      </Layout>
    </>
  );
};

export default NotFoundPage;
